<template>
	<aside id="sidebar-left" class="sidebar-left">
		<span class="notices-button menu-icon-container menu-profile mobile-notices-button">					
			<img :src="require('@/assets/img/notice.svg')" class="menu-icon">
			<span v-if="unread" class="blue-circle">{{ unread }}</span>
		</span>
		<div class="mobile-menu-button-close">
			<font-awesome-icon  icon="fa-xmark" size="2xl" />
		</div>		
		<div class="logo-container">
			<span @click="goToHome()" style="cursor: pointer;">				
				<LottieAnimation
					ref="anim"
					:animationData="require('@/assets/img/logoright-logo.json')"
					:loop="true"
					:autoPlay="true"
					/>					
			</span>			
			<span class="collapse-expand-menu">
				<font-awesome-icon class="collapse-menu-icon" icon="fa-angle-left" size="xs" />
				<font-awesome-icon class="expand-menu-icon" icon="fa-angle-right" size="xs" />
			</span>						
		</div>		
		<div class="nano" :style="'background-image: url(' + require('@/assets/img/vector-243.svg') + ')'">
			<div class="nano-content">
				<nav id="menu" class="nav-main" role="navigation">
					<ul class="nav nav-main">
						<li class="nav-parent nav-mobile" v-if="loggedInUserData.user_id" style="margin-bottom: 25px;">
							<a class="nav-link">
								<span class="menu-icon-container" title="">
									<img class="menu-icon admin-part" :src="require('@/assets/img/user.svg')">
								</span>
								<span>{{loggedInUserData.first_name ? loggedInUserData.last_name + " " + loggedInUserData.first_name + " " + loggedInUserData.patronymic : loggedInUserData.company_title}}</span>
							</a>
						</li>
						<li class="nav-parent nav-mobile" v-if="!loggedInUserData.user_id">
							<span class="mobile-button mobile-button-login" @click="loginNow()"><img :src="require('@/assets/img/login.svg')">Вход</span>
						</li>
						<li class="nav-parent nav-mobile" v-if="!loggedInUserData.user_id" style="margin-top: 25px;">
							<span class="mobile-button mobile-button-signup" @click="signupNow()">Регистрация</span>
						</li>
						<li class="nav-parent nav-mobile" v-if="loggedInUserData.user_id">
							<span class="mobile-button mobile-button-logout" @click="logoutNow()">Выход в кабинета<img :src="require('@/assets/img/logout.svg')"></span>
						</li>
						<!-- <li class="nav-parent nav-mobile" v-if="!loggedInUserData.user_id">
							<a class="nav-link" @click="loginNow()">
								<span class="menu-icon-container" title="Вход">
									<img class="menu-icon admin-part" :src="require('@/assets/img/login.svg')">
								</span>
								<span>Вход</span>
							</a>
						</li>
						<li class="nav-parent nav-mobile" v-if="loggedInUserData.user_id">
							<a class="nav-link" @click="logoutNow()">
								<span class="menu-icon-container" title="Выход в кабинета">
									<img class="menu-icon admin-part" :src="require('@/assets/img/logout.svg')">									
								</span>
								<span>Выход в кабинета</span>
							</a>
						</li>
						<li class="nav-parent nav-mobile" v-if="!loggedInUserData.user_id">
							<a class="nav-link" @click="signupNow()">
								<span class="menu-icon-container" title="Регистрация">
									<img class="menu-icon admin-part" :src="require('@/assets/img/login.svg')">
								</span>
								<span>Регистрация</span>
							</a>
						</li>
						<li class="nav-parent nav-mobile" v-if="loggedInUserData.user_id">
							<a class="nav-link">
								<span class="menu-icon-container" title="">
									<img class="menu-icon admin-part" :src="require('@/assets/img/user.svg')">
								</span>
								<span>{{loggedInUserData.first_name ? loggedInUserData.last_name + " " + loggedInUserData.first_name + " " + loggedInUserData.patronymic : loggedInUserData.company_title}}</span>
							</a>
						</li> -->
						<li class="nav-parent">&nbsp;</li>
						<template v-for="(firstLevel, firstIndex) in menu">
							<li :class="{ 'nav-parent': firstLevel.child, 'profile-item': firstLevel.href == '/user/profile' }" v-if="firstLevel.href && displayRow(firstLevel)" :key="firstIndex">
								<router-link class="nav-link" :class="{'profile-link': firstLevel.href == '/user/profile'}" :to="firstLevel.href">
									<span class="menu-icon-container" :title="firstLevel.title">
										<!-- <font-awesome-icon class="menu-icon" :class="{'admin-part': firstLevel.admin_rights}" :icon="firstLevel.icon" size="lg" /> -->
										<img :src="require('@/assets/img/' + firstLevel.icon + '.svg')" class="menu-icon">
									</span>
									<!-- <span :class="{'admin-part': firstLevel.admin_rights}">{{ firstLevel.title }} <span v-if="unread && firstLevel.href == '/user/profile'" class="blue-circle">{{ unread }}</span></span> -->
									<span>{{ firstLevel.title }}</span>																		
								</router-link>
								<span v-if="firstLevel.href == '/user/profile'" class="notices-button desktop-notices-button menu-icon-container menu-profile" :title="firstLevel.title">
									<img :src="require('@/assets/img/notice.svg')" class="menu-icon">
									<span v-if="unread && firstLevel.href == '/user/profile'" class="blue-circle">{{ unread }}</span>
								</span>
								
								<!-- <a v-else-if="!firstLevel.href && displayRow(firstLevel)" class="nav-link" @click="firstLevel.expanded = !firstLevel.expanded">
									<span class="menu-icon-container" :title="firstLevel.title">
										<font-awesome-icon class="menu-icon" :icon="firstLevel.icon" size="lg" />
										<img :src="require('@/assets/img/' + firstLevel.icon + '.svg')" class="menu-icon" :class="{'admin-part': firstLevel.admin_rights}">
									</span>	
									<span>{{ firstLevel.title }}</span>
									<font-awesome-icon v-if="firstLevel.child && firstLevel.expanded" class="menu-arrow"
										icon="angle-up" size="lg" />
									<font-awesome-icon v-else-if="firstLevel.child && !firstLevel.expanded"
										class="menu-arrow" icon="angle-down" size="lg" />
								</a> -->
								<!-- <ul v-if="firstLevel.child" class="nav nav-children nav-children-1" :key="'c' + firstIndex">
									<li v-for="(secondLevel, secondIndex) in (firstLevel.lessons ? menuLessons : firstLevel.child)"
										:key="secondIndex" :class="{ 'nav-parent': secondLevel.child }">
										<router-link v-if="secondLevel.href && (displayRow(secondLevel) || loggedInUserData.mik_rights)" class="nav-link" :to="secondLevel.href">
											{{ secondLevel.number ? secondLevel.number + '. ' : '' }}{{ secondLevel.title }}
										</router-link>
										<a v-if="!secondLevel.href && (displayRow(secondLevel) || loggedInUserData.mik_rights)" class="nav-link" @click="secondLevel.expanded = !secondLevel.expanded">									
											{{ secondLevel.number ? secondLevel.number + '. ' : '' }}{{ secondLevel.title }}
											<font-awesome-icon v-if="secondLevel.expanded" class="menu-arrow"
												icon="angle-up" size="lg" />
											<font-awesome-icon v-else-if="!secondLevel.expanded" class="menu-arrow"
												icon="angle-down" size="lg" />
										</a>
										<ul v-if="secondLevel.child" class="nav nav-children nav-children-2">
											<li v-for="(thirdLevel, thirdIndex) in secondLevel.child" :key="thirdIndex">											
												<router-link :id="'nav-link-' + thirdLevel.lesson_id" class="nav-link" :to="thirdLevel.href">{{ thirdLevel.number ? thirdLevel.number + '. ' : '' }}{{ thirdLevel.title }}
												</router-link>
											</li>
										</ul>
									</li>								
								</ul> -->
							</li>
						</template>
						<li v-if="!loggedInUserData.user_id || loggedInUserData.admin_rights">&nbsp;</li>
					</ul>
				</nav>
			</div>
		</div>
		<div class="notice-box">
			<div class="notice-box-scroll">
				<div v-for="(item, index) in tableData" :key="index" :class="item.viewed ? 'notice-item-viewed' : ''">
					{{ item.content }}
					<span><span v-if="!item.viewed"></span>{{ item.received }}</span>
				</div>	
			</div>
		</div>
	</aside>	
</template>

<script>
import axios from 'axios'
import $ from "jquery";
import LottieAnimation from 'lottie-web-vue'

export default {

	name: 'SideBar',

	props: ["logout", "login"],

	components: {
		LottieAnimation
	},

	watch: {
		logout: function(val){
			console.log("Logout in SideBar", val)
			this.loggedInUserData = []
		},
		login: function(val){
			console.log("Login in SideBar", val)
			this.loggedInUserData = JSON.parse(localStorage.getItem('app_user_data')) || false
		}
	},

	data() {
		return {
			loggedInUserData: JSON.parse(localStorage.getItem('app_user_data')) || false,
			appTitle: localStorage.getItem('app_title'),			
			menuLessons: [],
			unread: 0,
			unreadList: [],
			total: 0,
			tableData: [],
			viewloading: false,
			menu: [
				{
					href: '/check',
					title: 'Проверка товарного знака',
					// icon: 'fa-solid fa-spell-check',
					icon: 'icon-0',
					instructor_rights: false,
					mik_display: false,
					need_auth: false,
					only_user: false
				},			
				{
					href: '/calc',
					title: 'Калькулятор стоимости',
					// icon: 'fa-solid fa-calculator',
					icon: 'icon-1',
					instructor_rights: false,
					mik_display: false,
					need_auth: false,
					only_user: false
				},				
				{
					href: '/application/view',
					title: 'Мои заявки',
					// icon: 'fa-solid fa-briefcase',
					icon: 'icon-3',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: true
				},
				{
					href: '/application/create',
					title: 'Создать заявку',
					// icon: 'fa-solid fa-square-plus',
					icon: 'icon-4',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: true
				},
				{
					href: '/mytrademarks',
					title: 'Мои товарные знаки',
					// icon: 'fa-solid fa-envelopes-bulk',
					icon: 'icon-5',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: true
				},
				{
					href: '/contacts',
					title: 'Контакты',
					// icon: 'fa-solid fa-envelopes-bulk',
					icon: 'icon-5',
					instructor_rights: false,
					mik_display: false,
					need_auth: false,
					only_user: false
				},
				// {
				// 	href: '/user/notices',
				// 	title: 'Уведомления',
				// 	// icon: 'fa-solid fa-bell',
				// 	icon: 'icon-0',
				// 	instructor_rights: false,
				// 	mik_display: false,
				// 	need_auth: true,
				// 	only_user: false
				// },
				{
					href: '/admin/applications',
					title: 'Админ — Заявки',
					// icon: 'fa-solid fa-users-cog',
					icon: 'icon-7',
					instructor_rights: false,
					admin_rights: true,
					mik_display: false,
					need_auth: true,
					only_user: false
				},
				{
					href: '/admin/users',
					title: 'Админ — Пользователи',
					// icon: 'fa-solid fa-users-cog',
					icon: 'icon-8',
					instructor_rights: false,
					admin_rights: true,
					mik_display: false,
					need_auth: true,
					only_user: false
				},	
				{
					href: '/user/profile',
					title: 'Мой профиль',
					// icon: 'fa-solid fa-user-gear',
					icon: 'icon-2',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: true
				}				
			]
		}
	},

	created() {
				
	},

	mounted() {	

		var vueThis = this		

		// Анимация разворачивания списков меню до текущего пункта в случае перезагрузки приложения
		setTimeout(() => {
			$(".router-link-active").parents(".nav-children-1").slideToggle(500, function () {
				$(".router-link-active").parents(".nav-children-2").slideToggle(500);
			});			
		}, 500);

		// Скорость раскрытия и закрытия бокового меню (мс)
		var collapseSpeed = localStorage.getItem('app_collapse_speed');

		// Запуск функции обновления информации о непрочитанных уведомлениях
		setTimeout(this.getUnreadNotices, 1000);

		// Метод закрытия меню
		function collapseMenu() {
			$(".sidebar-left").animate({
				width: [ "73px", "swing" ]					
			}, collapseSpeed, "linear");
			$(".logo-container span:first-child").animate({
				width: [ "0px", "swing" ],
				opacity: [ "0", "swing" ]					
			}, collapseSpeed, "linear");
			$("a.nav-link span:nth-child(2), ul.nav-main li .nav-children li a, .menu-arrow").animate({	
				width: [ "0px", "swing" ],			
				opacity: [ "0", "swing" ]					
			}, collapseSpeed, "linear");
			$(".collapse-expand-menu").animate({
				width: [ "26px", "swing" ],	
				right: [ "26px", "swing" ]			
			}, collapseSpeed, "linear");
			$(".collapse-menu-icon").fadeOut(collapseSpeed / 2, function() {
				$(".expand-menu-icon").fadeIn(collapseSpeed / 2);				
			});
			$(".menu-profile").fadeOut(collapseSpeed / 2);	
			// $(".blue-circle").fadeOut(collapseSpeed / 2);
			$(".desktop-notices-button").fadeOut(collapseSpeed / 2);		
			$(".content-body").animate({
				marginLeft: [ "75px", "swing" ]					
			}, collapseSpeed, "linear");
			$(".user-bar").animate({
				paddingLeft: [ "75px", "swing" ]					
			}, collapseSpeed, "linear", function() {
				$(".materials-slide-container").css("width", "calc(100% - 75px)");	
				$(".material-layer-blank").css("width", "calc(100% - 75px)");	
				$(".material-layer-blank").css("marginLeft", "75px");								
			});					
			$(".nav-parent > .nav-children:visible").each(function(){				
				$(this).siblings(".nav-link").trigger("click");		
			});
						
		}

		// Метод раскрытия меню
		function expandMenu() {
			$(".sidebar-left").animate({
				width: [ "296px", "swing" ]					
			}, collapseSpeed, "linear");					
			$(".logo-container span:first-child").animate({
				width: [ "302px", "swing" ],
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");
			$("a.nav-link span:nth-child(2)").animate({	
				width: [ "240px", "swing" ],			
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");
			$("ul.nav-main li .nav-children li a").animate({	
				width: [ "330px", "swing" ],			
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");					
			$(".menu-arrow").animate({
				width: [ "12px", "swing" ],
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");					 
			$(".collapse-expand-menu").animate({
				width: [ "26px", "swing" ],
				right: [ "20px", "swing" ]						
			}, collapseSpeed, "linear");
			$(".expand-menu-icon").fadeOut(collapseSpeed / 2, function() {
				$(".collapse-menu-icon").fadeIn(collapseSpeed / 2);				
			});
			$(".menu-profile").fadeIn(collapseSpeed / 2);
			// $(".blue-circle").fadeIn(collapseSpeed / 2);
			$(".desktop-notices-button").fadeIn(collapseSpeed / 2);	
			$(".blue-circle").animate({	
				width: [ "16px", "swing" ],			
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");
			$(".content-body").animate({
				marginLeft: [ "296px", "swing" ]					
			}, collapseSpeed, "linear");
			$(".user-bar").animate({
				paddingLeft: [ "296px", "swing" ]					
			}, collapseSpeed, "linear", function() {
				$(".materials-slide-container").css("width", "calc(100% - 296px)");	
				$(".material-layer-blank").css("width", "calc(100% - 296px)");	
				$(".material-layer-blank").css("marginLeft", "296px");							
			});
		}

		$(document).ready(() => {

			if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) { 
				$(window).resize(function () {
					location.reload()
				});
			}
			
			// $("#menu").delegate(".nav-link", "click", function(){
			// 	console.log("Menu item .nav-link clicked.");
			// 	$(this).parent(".nav-parent").find("ul:first").slideToggle(500);
			// });

			// $(".notices-button").on("click", function(e){
			// 	e.preventDefault()
			// 	// e.stopPropagation();
			// 	vueThis.getNotices()
			// 	$(".notice-box").fadeIn(500)
			// })

			$( "aside" ).delegate( ".notices-button", "click", function(e) {
				e.preventDefault()
				e.stopPropagation()
				vueThis.getNotices()
				$(".notice-box").fadeIn(500)
				setTimeout(() => {
					async function sendSequentialRequests(items) {
						for (const item of items) {
							try {
								let notice_id = Number(item.notice_id)
								const response = await axios({
									url: `/notices/${notice_id}`, 
									data: {}, 
									method: 'PATCH'
								})
								console.log("Ответ для id", item.notice_id, response.data)								
							} catch (error) {
								console.error("Ошибка для id", item.notice_id, error)
							}
						}
						console.log("Все запросы завершены")
					}
					sendSequentialRequests(vueThis.unreadList)						
				}, 120000);
			})	

			$(document).on('click', function (e) {
				if (!$(e.target).closest('.notice-box').length) {
					$('.notice-box').fadeOut(500);
				}
			});

			if(window.innerWidth > 992){

				var menuCollapsed = localStorage.getItem('app_menu_collapsed') || 0;
				
				if(menuCollapsed == 1){
					$('.expand-menu-icon').css("display", "inline-block");
					collapseMenu();
				}else{
					$('.collapse-menu-icon').css("display", "inline-block");
					expandMenu();
				}

				$(".collapse-expand-menu").click(function(){
					menuCollapsed = localStorage.getItem('app_menu_collapsed') || 0;
					if(menuCollapsed == 1){
						expandMenu();
						localStorage.setItem('app_menu_collapsed', 0);
					}else{
						collapseMenu();
						localStorage.setItem('app_menu_collapsed', 1);
					}
				})

			}	

		});		

	},		

	methods: {

		goToHome() {
			if(this.$router.currentRoute.path != "/"){
				this.$router.push("/")
			}
		},
		
		getUnreadNotices() {
			
			axios({ url: `/notices?unread=1`, method: 'GET' })
				.then(response => {
					this.viewloading = false
					if (response.status == 200 && response.data && response.data.data) {
						this.unread = Number(response.data.total)
						this.unreadList = response.data.data
					}
				})
				.catch(error => {
					this.viewloading = false						
					if(error && error.response && error.response.data && error.response.data.message){
						//this.msg.value = "Ошибка при загрузке заявок"
						//this.msg.details = error.response.data.message
						//this.msg.type = 2
					}else{
						this.msg.value = "Ошибка при загрузке уведомлений"
						this.msg.details = error
						this.msg.type = 2
					}
					this.unread = 0					
				})				
			setTimeout(this.getUnreadNotices, 15000)	
		},

		getNotices() {			
			
			//axios({ url: '/notices?start=' + ((this.currentPage - 1) * this.perPage) + '&count=' + this.perPage, method: 'GET' })
			axios({ url: '/notices?start=0&count=30', method: 'GET' })
				.then(response => {
					this.viewloading = false
					if (response.status == 200 && response.data && response.data.data) {
						this.total = response.data.total
						this.tableData = []
						response.data.data.forEach(item => {																																	
							this.tableData.push({
								number: item.notice_id,
								received: item.public_date,
								content: item.content,
								viewed: item.viewed
							})						
						})
					}
				})
				.catch(error => {
					this.viewloading = false						
					if(error && error.response && error.response.data && error.response.data.message){
						this.msg.value = "Ошибка при загрузке уведомлений"
						this.msg.details = error.response.data.message
						this.msg.type = 2
					}else{
						this.msg.value = "Ошибка при загрузке уведомлений"
						this.msg.details = error
						this.msg.type = 2
					}					
				})				
		},
		
		setNoticeRead(notice) {
			const notice_id = Number(notice)
			axios({
				url: `/notices/${notice_id}`, 
				data: {}, 
				method: 'PATCH'
			})
			.then(response => {																
				if(response.status == 200 && response.data && response.data.message){											
					console.log(response.data.message)
					this.getNotices()
				}
			})
			.catch(error => {	
				if(error && error.response && error.response.data && error.response.data.message){
					this.msg.type = 2
					this.msg.value = "Ошибка! Не удалось обновить уведомление"
					this.msg.details = error.response.data.message
				}else{
					this.msg.type = 2
					this.msg.value = "Ошибка! Не удалось обновить уведомление"
					this.msg.details = error
				}
			})			
		},	
		
		logoutNow(){
			localStorage.removeItem('app_user_data')
			localStorage.removeItem('app_token')
			delete axios.defaults.headers.common['Authorization']
			this.loggedInUserData = []
			this.$emit('onLogout', true)
			if(this.$router.currentRoute.path != "/login"){
				this.$router.push("/login")
			}			
		},

		signupNow(){
			if(this.$router.currentRoute.path != "/signup"){
				this.$router.push("/signup")
			}
		},

		loginNow(){
			if(this.$router.currentRoute.path != "/login"){
				this.$router.push("/login")
			}
		},

		// Метод отображения пункта меню
		displayRow(item) {
			if(item.need_auth == true){
				if(this.loggedInUserData.user_id > 0){
					if(item.admin_rights){
						if(this.loggedInUserData.admin_rights){
							return true
						}else{
							return false
						}
					}else if(item.only_user){
						if(this.loggedInUserData.admin_rights){
							return false
						}else{
							return true
						}
					}else{
						return true
					}
				}else{
					return false
				}	
			}else{
				return true
			}										
		}		
	}
}
</script>

<style>

.collapse-expand-menu {
	background-color: #CCA1F5;
	cursor: pointer;
	position: absolute;
	top: 50px;
	right: 20px;
	text-align: center;
	width: 20px !important;
	height: 20px !important;
	padding: 0;
	border-radius: 2px;
	font-size: 17px;
}

/* .collapse-expand-menu:hover {
	background-color: #000;
}	 */

.collapse-menu-icon,
.expand-menu-icon {
	color: #FFFFFF;
	display: none;	
	margin-top: 0px;	
}	

.instructor-command {
	width: 100%; 
	background-color: #ffdb29; 
	color: #333; 
	text-align: center;
	padding: 15px;
	margin-top: 1px;
}

.instructor-command input {
	background-color: #1D2127;
	margin-top: 10px;
}	

.instructor-command input:hover {
	background-color: #000;
}



</style>